<template>
  <vxe-grid
    resizable
    class="mb-2 process-history"
    :data="serverConfigs"
    :columns="serverConfigColumns" />
</template>

<script>
import { sizestr } from '@/utils/utils'
import { STORAGE_TYPES } from '@/constants/compute'
import { HYPERVISORS_MAP } from '@/constants'
import { MEDIUM_TYPES } from '@Storage/constants'
import { CHANGE_TYPES } from '../utils'

export default {
  name: 'ServerConfigList',
  props: {
    variables: {
      type: Object,
      default: function () {
        return {}
      },
    },
    /** 直接传入配置列表，避免仅依赖 variables.serverConf 字符串 */
    configs: {
      type: Array,
      default: null,
    },
  },
  data () {
    return {
      serverConfigColumns: [
        {
          field: 'name',
          title: this.$t('common_388'),
          minWidth: 80,
          showOverflow: 'title',
          formatter: ({ cellVal, row }) => {
            return row.name
          },
        },
        {
          field: 'project',
          title: this.$t('common_389'),
          minWidth: 80,
          showOverflow: 'title',
          formatter: ({ cellVal, row }) => {
            return row.project
          },
        },
        {
          field: 'change_type',
          title: this.$t('common_56'),
          minWidth: 40,
          showOverflow: 'title',
          formatter: ({ cellVal, row }) => {
            return CHANGE_TYPES[this.variables.change_type] || this.$t('common.change_config')
          },
        },
        {
          field: 'beforeConfig',
          title: this.$t('common_395'),
          minWidth: 120,
          showOverflow: 'title',
          className: 'table--td-auto-height',
          slots: {
            default: ({ row }) => {
              if (row.before && (row.before.hasOwnProperty('dataDisks') || row.before.hasOwnProperty('sysDisks'))) {
                const sku = row.before.sku ? ` （${row.before.sku}）` : ''
                const ret = []
                ret.push(`${row.before && row.before.cpu}${this.$t('common.c')}${sizestr(row.before && row.before.memory, 'M', 1024)}${sku}`)
                if (row.before.sysDisks) {
                  row.before.sysDisks.forEach(item => {
                    let type = ''
                    if (HYPERVISORS_MAP[row.hypervisor]) {
                      type = STORAGE_TYPES[HYPERVISORS_MAP[row.hypervisor].key][item.backend || item.type].label
                    }
                    ret.push(<div>{`${this.$t('compute.text_49')}: ${item.size ? sizestr(item.size || 0, 'M', 1024) : (item.value || 0) + 'G'}`}{type ? ' ' + type : ''}{item.medium_type && MEDIUM_TYPES[item.medium_type] ? ' ' + MEDIUM_TYPES[item.medium_type] : ''}</div>)
                  })
                }
                if (row.before.dataDisks) {
                  row.before.dataDisks.forEach(item => {
                    let type = ''
                    if (HYPERVISORS_MAP[row.hypervisor]) {
                      type = STORAGE_TYPES[HYPERVISORS_MAP[row.hypervisor].key][item.backend || item.type].label
                    }
                    ret.push(<div>{`${this.$t('compute.text_50')}: ${item.size ? sizestr(item.size || 0, 'M', 1024) : (item.value || 0) + 'G'}`}{type ? ' ' + type : ''}{item.medium_type && MEDIUM_TYPES[item.medium_type] ? ' ' + MEDIUM_TYPES[item.medium_type] : ''}</div>)
                  })
                }
                return ret
              }
              if (row.before && row.before.tx_bw_limit !== undefined && row.before.tx_bw_limit !== 0 && row.before.rx_bw_limit !== undefined && row.before.rx_bw_limit !== 0) {
                let ret = `${this.$t('compute.bandwidth.tx.title')}:`
                if (+row.before.tx_bw_limit) {
                  ret += `${row.before.tx_bw_limit}Mbps`
                } else {
                  ret += `0(${this.$t('common.not_limited')})`
                }
                ret += `/${this.$t('compute.bandwidth.rx.title')}:`
                if (+row.before.rx_bw_limit) {
                  ret += `${row.before.rx_bw_limit}Mbps`
                } else {
                  ret += `0(${this.$t('common.not_limited')})`
                }
                if (row.ip_addr) {
                  ret += ` (${row.ip_addr})`
                }
                return ret
              }
              if (row.before && row.before.bw_limit !== undefined) {
                if (+row.before.bw_limit) {
                  return `${row.before.bw_limit}Mbps (ip: ${row.ip_addr || ''})`
                }
                return `0(${this.$t('common.not_limited')})`
              }
              return `${row.before && row.before.cpu}${this.$t('common.c')}${sizestr(row.before && row.before.memory, 'M', 1024)}${sizestr(row.before && row.before.disk, 'M', 1024)}`
            },
          },
        },
        {
          field: 'afterConfig',
          title: this.$t('common_397'),
          minWidth: 120,
          showOverflow: 'title',
          className: 'table--td-auto-height',
          slots: {
            default: ({ row }) => {
              if (this.serverConfigs.length === 1) {
                if (row.after && (row.after.hasOwnProperty('dataDisks') || row.after.hasOwnProperty('sysDisks'))) {
                  const sku = row.after.sku ? ` （${row.after.sku}）` : ''
                  const ret = []
                  ret.push(<div>{`${row.after && row.after.cpu}${this.$t('common.c')}${sizestr(row.after && row.after.memory, 'M', 1024)}${sku}`}</div>)
                  const sysDisks = (row.after.sysDisks && row.after.sysDisks.length)
                    ? row.after.sysDisks
                    : (row.before && row.before.sysDisks)
                  const dataDisks = (row.after.dataDisks && row.after.dataDisks.length)
                    ? row.after.dataDisks
                    : (row.before && row.before.dataDisks)
                  if (sysDisks && sysDisks.length) {
                    sysDisks.forEach(item => {
                      let type = ''
                      if (HYPERVISORS_MAP[row.hypervisor]) {
                        type = STORAGE_TYPES[HYPERVISORS_MAP[row.hypervisor].key][item.backend || item.type].label
                      }
                      ret.push(<div>{`${this.$t('compute.text_49')}: ${item.size ? sizestr(item.size || 0, 'M', 1024) : (item.value || 0) + 'G'}`}{type ? ' ' + type : ''}{item.medium_type && MEDIUM_TYPES[item.medium_type] ? ' ' + MEDIUM_TYPES[item.medium_type] : ''}</div>)
                    })
                  }
                  if (dataDisks && dataDisks.length) {
                    dataDisks.forEach(item => {
                      let type = ''
                      if (HYPERVISORS_MAP[row.hypervisor]) {
                        type = STORAGE_TYPES[HYPERVISORS_MAP[row.hypervisor].key][item.backend || item.type].label
                      }
                      ret.push(<div>{`${this.$t('compute.text_50')}: ${item.size ? sizestr(item.size || 0, 'M', 1024) : (item.value || 0) + 'G'}`}{type ? ' ' + type : ''}{(item.medium_type || item.medium) && MEDIUM_TYPES[item.medium_type || item.medium] ? ' ' + MEDIUM_TYPES[item.medium_type || item.medium] : ''}</div>)
                    })
                  }
                  // 未带出磁盘明细时，至少展示总容量
                  if (ret.length === 1 && row.after.disk) {
                    ret[0] = <div>{`${row.after.cpu}${this.$t('common.c')}${sizestr(row.after.memory, 'M', 1024)}${sizestr(row.after.disk, 'M', 1024)}${sku}`}</div>
                  }
                  return ret
                }
              } else if (this.serverConfigs.length > 1) {
                if (row.before && (row.before.hasOwnProperty('dataDisks') || row.before.hasOwnProperty('sysDisks'))) {
                  const sku = row.after.sku ? ` （${row.after.sku}）` : ''
                  const ret = []
                  ret.push(`${row.after && row.after.cpu}${this.$t('common.c')}${sizestr(row.after && row.after.memory, 'M', 1024)}${sku}`)
                  if (row.before.sysDisks) {
                    row.before.sysDisks.forEach(item => {
                      let type = ''
                      if (HYPERVISORS_MAP[row.hypervisor]) {
                        type = STORAGE_TYPES[HYPERVISORS_MAP[row.hypervisor].key][item.backend || item.type].label
                      }
                      ret.push(<div>{`${this.$t('compute.text_49')}: ${item.size ? sizestr(item.size || 0, 'M', 1024) : (item.value || 0) + 'G'}`}{type ? ' ' + type : ''}{item.medium_type && MEDIUM_TYPES[item.medium_type] ? ' ' + MEDIUM_TYPES[item.medium_type] : ''}</div>)
                    })
                  }
                  if (row.before.dataDisks) {
                    row.before.dataDisks.forEach(item => {
                      let type = ''
                      if (HYPERVISORS_MAP[row.hypervisor]) {
                        type = STORAGE_TYPES[HYPERVISORS_MAP[row.hypervisor].key][item.backend || item.type].label
                      }
                      ret.push(<div>{`${this.$t('compute.text_50')}: ${item.size ? sizestr(item.size || 0, 'M', 1024) : (item.value || 0) + 'G'}`}{type ? ' ' + type : ''}{item.medium_type && MEDIUM_TYPES[item.medium_type] ? ' ' + MEDIUM_TYPES[item.medium_type] : ''}</div>)
                    })
                  }
                  return ret
                }
              }
              if (row.after && row.after.tx_bw_limit !== undefined && row.after.rx_bw_limit !== undefined) {
                let ret = `${this.$t('compute.bandwidth.tx.title')}:`
                if (+row.after.tx_bw_limit) {
                  ret += `${row.after.tx_bw_limit}Mbps`
                } else {
                  ret += `0(${this.$t('common.not_limited')})`
                }
                ret += `/${this.$t('compute.bandwidth.rx.title')}:`
                if (+row.after.rx_bw_limit) {
                  ret += `${row.after.rx_bw_limit}Mbps`
                } else {
                  ret += `0(${this.$t('common.not_limited')})`
                }
                if (row.ip_addr) {
                  ret += ` (${row.ip_addr})`
                }
                return ret
              }
              if (row.after && row.after.bw_limit !== undefined) {
                if (+row.after.bw_limit) {
                  return `${row.after.bw_limit}Mbps (ip: ${row.ip_addr || ''})`
                }
                return `0(${this.$t('common.not_limited')})`
              }
              if (this.serverConfigs.length === 1) {
                if (row.after && row.after.disk) {
                  return `${row.after && row.after.cpu}${this.$t('common.c')}${sizestr(row.after && row.after.memory, 'M', 1024)}${sizestr(row.after && row.after.disk, 'M', 1024)}`
                }
              }
              return `${row.after && row.after.cpu}${this.$t('common.c')}${sizestr(row.after && row.after.memory, 'M', 1024)}`
            },
          },
        },
      ],
    }
  },
  computed: {
    serverConfigs () {
      if (Array.isArray(this.configs) && this.configs.length) {
        return this.configs
      }
      try {
        const parsed = JSON.parse(this.variables.serverConf || '[]')
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
  },
}
</script>
